import { useQuery } from "@tanstack/react-query";
import { campaignsQueryOptions, getCampaignTagsForProduct, type CampaignTagInfo } from "./dal";
import type { ProductCard } from "@/lib/centra";
import type { CampaignTag } from "@/features/products/ProductCard/ProductCard";
import { useGlobal } from "@/features/global/GlobalContext";
import { useSelection } from "@frend-digital/centra/client";

export const useCampaigns = () => {
	return useQuery(campaignsQueryOptions);
};

export const useCampaignTagsForProduct = (product: ProductCard): CampaignTag[] => {
	const { data: campaigns } = useCampaigns();
	const { data: globalData } = useGlobal();

	// Get current market and pricelist from Centra selection
	const selection = useSelection({
		select: (data) => ({
			market: data.location?.market,
			pricelist: data.location?.pricelist,
		}),
	});

	const matchedCampaigns: CampaignTagInfo[] = getCampaignTagsForProduct(
		campaigns,
		product.displayItemId,
		product.sku || product.centraProductNumber,
		selection.data?.market?.toString(),
		selection.data?.pricelist?.toString(),
	);

	return matchedCampaigns
		.map((campaign: CampaignTagInfo) => {
			// Look up tag config by campaign ID
			const tagConfig = globalData.tags[campaign.id];
			return {
				name: tagConfig?.name,
				color: tagConfig?.color,
			};
		})
		.filter((tag) => tag.name);
};
